export default "__VITE_ASSET__DPj9IM1u__"